<script setup>
import MarkdownRender from 'markstream-vue';

defineProps({
	message: {
		type: Object,
		required: true
	}
});
</script>

<template>
  <div class="message-wrapper assistant">
    <div class="message-bubble assistant">
      <div class="message-content">
        <MarkdownRender
          :content="message.content"
          :show-tooltips="false"
        />
      </div>
    </div>
  </div>
</template>
